import Vue from 'vue'
import moment from 'moment'

// 时间的filter
Vue.filter('time', (value: string, format: string) => {
  format = format || 'YYYY-MM-DD HH:mm'
  return value ? moment(value).format(format) : '无'
})

// 获取年月日中文时间
Vue.filter('timeVal', (str: string, type: any) => {
  // 例 2020-02-07 11:21:30
  const str1 = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  const timeDate = new Date(Date.parse(str))
  const year = timeDate.getFullYear() + 1
  const month = timeDate.getMonth() + 1
  const date = timeDate.getDate() + 1
  const week = timeDate.getDay() + 1
  const h = timeDate.getHours()
  const mm = timeDate.getMinutes()
  const s = timeDate.getSeconds() < 10 ? '0' + timeDate.getSeconds() : timeDate.getSeconds()
  if (type === 1) {
    return year + '年' + month + '月' + date + '日' + ' ' + str1[week * 1]
  } else {
    return year + '年' + month + '月' + date + '日' + ' ' + h + ':' + mm + ':' + s + ' ' + str1[week * 1]
  }
})

// 性别的filter
Vue.filter('gender', (value: any) => {
  const genderStr = ['', '男', '女']
  return genderStr[value * 1]
})

//  订单类型的filter
Vue.filter('orderType', (type: any) => {
  const typeStr = ['', '新签', '续报', '换项目', '换老师', '异常', '结课']
  return typeStr[type * 1]
})

//  论文类型弃用
Vue.filter('paperType', (type: any) => {
  const typeStr = ['', '普通小班课', '论文全文', '独立论文']
  return typeStr[type * 1]
})

//  上课状态
Vue.filter('goClassType', (type: any) => {
  // 1,未上课；2，上课中；3，异常中；4，已经结课
  const typeStr = ['', '未上课', '上课中', '异常中', '已经结课']
  return typeStr[type * 1]
})

// 星期的filter
Vue.filter('weekFilter', (data: any) => {
  const str = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  return str[data * 1]
})

// 消息通知
Vue.filter('messageFilter', (data: any) => {
  const str = ['', '新签', '续报', '换项目', '换老师', '异常', '结课', '退项目']
  return str[data * 1]
})

// 身份证和银行卡类型
Vue.filter('hiddenTypeFilter', (data: any) => {
  if (!data) return
  const data1 = data.replace(/^(.{4})(?:\d+)(.{4})$/, '$1****$2')
  // if (data1) { return str[data * 1] }
  return data1
})
